<template>
  <div>
    <p class="text-xl font-medium">Filters</p>
  </div>

  <div class="flex h-96 border rounded-lg mt-4" :style="{ '--primary-color': primaryColor }">
    <div class="w-1/3 border-r border-gray-300">
      <ul>
        <li
          v-for="(tab, index) in filterTabs"
          :key="index"
          @click="activeTab = index"
          class="cursor-pointer p-5 text-sm transition relative"
          :class="{
            'text-primary font-medium bg-gradient-to-l from-primary-200 via-white to-white active-tab': activeTab === index,
            'text-gray-600 font-normal': activeTab !== index
          }"
        >
          {{ tab.label }}
        </li>
      </ul>
    </div>
    <div class="w-2/3 px-2 space-y-3 overflow-y-auto max-h-96 scrollbar-hide">
      <div v-if="activeTab === 0">
        <div class="flex items-center space-x-2 py-4 border-b border-gray-300">
          <URadio v-model="selectedFilters.date" :value="'All'"/>
          <span class="text-gray-700 font-medium text-sm">All</span>
        </div>
        <ul>
          <li v-for="(option, i) in filterByDate" :key="i" class="flex items-center space-x-2 justify-between">
            <span class="text-gray-700 text-sm p-4 font-normal">{{ option }}</span>
            <URadio
              v-model="selectedFilters.date"
              :value="option"
              :name="'date-filter'"
              class="pr-2"
            />         
          </li>
        </ul>
      </div>

      <div v-if="activeTab === 1">
      <ul>
        <li v-for="(option, i) in orderStatus" :key="i" class="flex items-center justify-between">
          <span class="text-gray-700 text-sm p-4 font-normal">{{ getStatusLabel(option) }}</span>
          <UCheckbox
            v-model="selectedFilters.status"
            :value="option"
            class="pr-2"
          />
        </li>
      </ul>
    </div>

      <div v-if="activeTab === 2">
        <div class="flex items-center space-x-2 py-4 border-b border-gray-300">
          <UCheckbox v-model="selectAllCategory" :value="true" @change="toggleSelectAll('category', categoryOptions)" />
          <span class="text-gray-700 font-medium text-sm">Select All</span>
        </div>
        <ul>
          <li v-for="(option, i) in categoryOptions" :key="i" class="flex items-center space-x-2 justify-between">
            <span class="text-gray-700 text-sm p-4 font-normal">{{ option }}</span>
            <UCheckbox v-model="selectedFilters.category" :value="option" class="pr-2" />
          </li>
        </ul>
      </div>
    </div>
  </div>

  <div class="shadow-2xl rounded-b-lg p-4">
    <div class="flex justify-between mt-4">
      <UButton color="white" variant="outline" class="md:w-2/5 w-5/12 text-nowrap text-gray-400 font-medium text-sm" @click="clearFilters"
        label="Clear Filter" />
      <UButton label="Apply" class="md:w-2/5 w-5/12 ml-2 font-medium text-sm" @click="applyFilters" />
    </div>
  </div>
</template>


<script setup>
import { getPrimaryColor } from '~/composables/theme';
const dayjs = useDayjs();
const activeTab = ref(0);
const order = useOrder();
const props = defineProps(['data']);
const emit = defineEmits(["success"]);
const selectedFilters = ref({
  date: order.filter.date, 
  status: order.filter.status,
  category: order.filter.category
});
const primaryColor = getPrimaryColor();

const filterTabs = computed(() => {
  const baseTabs = [
    { label: "Date" },
    { label: "Order Status" },
    { label: "Category" }
  ];

  return props.data?.activeTab === 'F&B' || props.data?.activeTab === 'Grocery'
    ? baseTabs.filter(tab => tab.label !== "Category")
    : baseTabs;
});

const filterByDate = ["Current Month", "Last 3 Months", "Last 6 Months"];
const orderStatus = ["Confirmed","Packed", "Dispatched","Out for delivery", "Completed","Cancelled", "Processing"];
const categoryOptions = [ "Fashion", "Beauty & personal care", "Electronics", "Home & kitchen","Health & wellness","Appliances"];
const statusLabelMap = {
  confirmed: "Confirmed",
  packed: "Packed",
  dispatched: "Dispatched",
  out_for_delivery: "Out for delivery",
  Completed: "Delivered",
  cancelled: "Cancelled",
  processing: "Processing"
};

const getStatusLabel = (status) => statusLabelMap[status] || status;
const selectAllStatus = ref(false);
const selectAllCategory = ref(false);

const selectedCount = computed(() => {
  let count = 0;
  if (selectedFilters.value.date) count += 1;
  count += selectedFilters.value.status.length;
  count += selectedFilters.value.category.length;
  return count;
});

const toggleSelectAll = (type, options) => {
  if (type === 'status') {
    selectedFilters.value.status = selectAllStatus.value ? [...orderStatus] : [];
  } else if (type === 'category') {
    selectedFilters.value.category = selectAllCategory.value ? [...categoryOptions] : [];
  }
};

const clearFilters = () => {
  selectedFilters.value = { date: "", status: [], category: [] }; 
  selectAllStatus.value = false;
  selectAllCategory.value = false;
};

const applyFilters = () => {
  const today = dayjs();
  order.addFilter(selectedFilters.value);
  if (selectedFilters.value.date === "Current Month") {
    selectedFilters.value.date = today.startOf("month").format("YYYY-MM-DD");
  } else if (selectedFilters.value.date === "Last 3 Months") {
    selectedFilters.value.date = today.subtract(3, "month").startOf("month").format("YYYY-MM-DD");
  } else if (selectedFilters.value.date === "Last 6 Months") {
    selectedFilters.value.date = today.subtract(6, "month").startOf("month").format("YYYY-MM-DD");
  } else {
    selectedFilters.value.date = "";
  }

  console.log("Selected Filters:", selectedFilters.value);
  emit("success", selectedFilters.value);
  emit("close");
};
</script>

<style>
.active-tab::after {
  content: "";
  position: absolute;
  right: 0;
  top: 0;
  width: 8px; /* thickness of the border */
  height: 100%;
  background-color: var(--primary-color);
  border-top-left-radius: 9999px;
  border-bottom-left-radius: 9999px;
}
</style>